import React, { ChangeEvent, useCallback } from 'react';
import styles from './CircleCheckbox.module.scss';

type Props = {
  id?: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  disabled?: boolean;
  isRoundRect?: boolean;
};

function CircleCheckbox(props: Props) {
  const { checked, onChange, disabled, label, id, isRoundRect } = props;
  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    onChange(e.target.checked);
  }, [disabled, onChange]);

  return (
    <div className={styles.container}>
      <div className={`${styles.round} ${isRoundRect ? styles.roundRect : ''}`}>
        <input type="checkbox" checked={checked} id={id || 'checkbox__'} onChange={handleChange} disabled={disabled} />
        <label htmlFor={id || 'checkbox__'}>{ label || '' }</label>
      </div>
    </div>
  );
}

export default CircleCheckbox;
